import type { AdminOrderData } from "../page";

interface Props {
  order: AdminOrderData;
}

export default function AdminOrderCustomer({ order }: Props) {
  return (
    <div className="bg-white border border-gray-100 rounded-2xl p-5 flex flex-col gap-4">
      <h3 className="font-bold text-[#1a1a1a] text-sm flex items-center gap-2">
        <div className="w-7 h-7 flex items-center justify-center bg-gray-50 rounded-lg">
          <i className="ri-user-3-line text-[#1a1a1a] text-sm"></i>
        </div>
        بيانات العميل
      </h3>

      {/* Avatar + name */}
      <div className="flex items-center gap-3 bg-gray-50 rounded-xl p-3">
        <div className="w-11 h-11 flex items-center justify-center bg-[#1a1a1a] rounded-xl flex-shrink-0">
          <span className="text-white font-black text-base">{order.name.charAt(0)}</span>
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-bold text-[#1a1a1a] text-sm truncate">{order.name}</p>
          {order.customerId ? (
            <span className="flex items-center gap-1 text-[10px] text-green-600 font-bold mt-0.5">
              <i className="ri-verified-badge-line text-xs"></i>
              عميل مسجّل
            </span>
          ) : (
            <span className="text-[10px] text-gray-400 mt-0.5">ضيف</span>
          )}
        </div>
      </div>

      {/* Info rows */}
      <div className="flex flex-col gap-2.5">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 flex items-center justify-center bg-green-50 rounded-lg flex-shrink-0">
            <i className="ri-smartphone-line text-green-600 text-sm"></i>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[10px] text-gray-400">رقم الجوال</p>
            <p className="text-sm font-bold text-[#1a1a1a] tracking-wider" dir="ltr">{order.phone}</p>
          </div>
          <a
            href={`tel:${order.phone}`}
            className="w-8 h-8 flex items-center justify-center rounded-lg bg-green-50 hover:bg-green-100 text-green-600 transition-colors cursor-pointer flex-shrink-0"
          >
            <i className="ri-phone-line text-sm"></i>
          </a>
        </div>

        <div className="flex items-center gap-3">
          <div className="w-8 h-8 flex items-center justify-center bg-sky-50 rounded-lg flex-shrink-0">
            <i className="ri-building-2-line text-sky-600 text-sm"></i>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[10px] text-gray-400">المدينة</p>
            <p className="text-sm font-bold text-[#1a1a1a]">{order.city}</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <div className="w-8 h-8 flex items-center justify-center bg-rose-50 rounded-lg flex-shrink-0 mt-0.5">
            <i className="ri-map-pin-2-line text-rose-500 text-sm"></i>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[10px] text-gray-400">العنوان</p>
            <p className="text-sm font-medium text-[#1a1a1a] leading-relaxed">{order.address}</p>
          </div>
        </div>

        {order.notes && order.notes !== "undefined" && order.notes.trim() && (
          <div className="flex items-start gap-3 bg-amber-50 border border-amber-100 rounded-xl px-3 py-2.5">
            <i className="ri-sticky-note-line text-amber-500 text-sm mt-0.5 flex-shrink-0"></i>
            <div>
              <p className="text-[10px] text-amber-600 font-bold mb-0.5">ملاحظات العميل</p>
              <p className="text-xs text-amber-800 leading-relaxed">{order.notes}</p>
            </div>
          </div>
        )}
      </div>

      {/* WhatsApp quick link */}
      <a
        href={`https://wa.me/${order.phone.replace(/^0/, "966")}?text=${encodeURIComponent(`مرحباً ${order.name}، بخصوص طلبك #${order.orderRef}`)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-2 bg-[#25D366]/10 hover:bg-[#25D366]/20 border border-[#25D366]/30 text-[#25D366] font-bold py-2.5 rounded-xl text-sm transition-all cursor-pointer whitespace-nowrap"
      >
        <i className="ri-whatsapp-line text-base"></i>
        تواصل مع العميل
      </a>
    </div>
  );
}
